import { styled } from '@mui/material/styles';

export const LoaderWrapper = styled('div')(({ theme }) => ({
	position: 'absolute',
	top: 0,
	left: 0,
	height: '100vh',
	width: '100%',
	display: 'grid',
	placeItems: 'center',
	background: theme.palette.neutral[100],
	opacity: 0.8,
	zIndex: 10,
}));

/** Viewport-covering variant, meant to be rendered through a Portal above all page UI. */
export const FullScreenLoaderWrapper = styled(LoaderWrapper)(({ theme }) => ({
	position: 'fixed',
	height: '100%',
	zIndex: theme.zIndex.modal,
}));
